module.exports = __webpack_public_path__ + "static/media/c7.94b35c6c.jpg";